import api from 'apis/users';
import AppConfig from 'constants/AppConfig';
import { NotificationManager } from 'react-notifications';
import { SET_LOADING_STATUS, SET_USER } from 'redux/types';
import IntlMessages from 'utils/intl-messages';

export const setUser = (user) => (dispatch) => {
  dispatch({ type: SET_USER, payload: user });
};

export const getUserById = (userId) => (dispatch) => {
  dispatch({ type: SET_LOADING_STATUS, payload: true });
  return api.getUserById(userId).then((user) => {
    dispatch({ type: SET_LOADING_STATUS, payload: false });
    dispatch({ type: SET_USER, payload: user.data });
    return Promise.resolve(user);
  });
};

// `silent` skips the generic error toast, for callers that show their own message for the failure.
export const addOrUpdateUser =
  (user, { silent = false } = {}) =>
  (dispatch) => {
    dispatch({ type: SET_LOADING_STATUS, payload: true });
    return api
      .addOrUpdateUser(user)
      .then((user) => {
        dispatch({ type: SET_LOADING_STATUS, payload: false });
        return Promise.resolve(user);
      })
      .catch((error) => {
        dispatch({ type: SET_LOADING_STATUS, payload: false });
        if (!silent) {
          NotificationManager.error(
            <IntlMessages id={`global.error.somethingWentWrong`} />,
            <IntlMessages id={`${AppConfig.errorTitle}`} />,
            AppConfig.errorNotificationTimeout
          );
        }
        return Promise.reject(error);
      });
  };
